import { Box, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import SelectComponent from "../FormComponents/DefaultSelect/SelectComponent";
import EntityDetails from "./Forms/EntityDetails";
import { dropdownOptions, dropdownsLoading, requesterDetailsFormState } from "../../features/CaptureDetailsSlice";
import EmailPhoneDetails from "./Forms/EmailPhoneDetails";
import { RequestorType } from "../../models/Enums";
import MenuItemsForDropdown from '../FormComponents/MenuItemsForDropdown/MenuItemsForDropdown';
import InputFieldComponent from "../FormComponents/InputField/InputField";
import { Field } from "react-final-form";
import HearingDisabledOutlinedIcon from '@mui/icons-material/HearingDisabledOutlined';

const CaptureRequesterDetails = () => {
  const loading = useSelector(dropdownsLoading);
  const selectOptions = useSelector(dropdownOptions);
  const captureDetailsForm = useSelector(requesterDetailsFormState);

  return (
    <Box
      sx={{
        pb: "22px",
        pt: "8px",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box sx={{ mt: "12px", backgroundColor: "#E3EFF57D", borderRadius: "8px", mb: "12px", p: "16px" }}>
        <Box sx={{ display: "flex", alignItems: "center", mb: "8px" }}>
          <HearingDisabledOutlinedIcon color="primary" />
          <Typography sx={{ color: "#00558B", fontWeight: "bold", ml: "8px" }}>Hearing Impaired</Typography>
        </Box>
        <Box>
          <label id="checkbox-label">
            <Field
              name="hearingImpaired"
              component="input"
              type="checkbox"
              format={value => value}
              parse={value => (value ?? false)}
              id="hearing-impaired-checkbox-control"
            />{" "}
            Please mark this checkbox if the person that will be attending the session is hearing impaired.
          </label>
        </Box>
      </Box>

      <h2 style={{paddingBottom: "12px", fontSize: "24px", fontWeight: "normal", marginTop: 0, marginBottom: 0}}>
        Requestor Details
      </h2>
      <Box sx={{ mt: "4px" }}>
        <Box sx={{ display: "flex", flexWrap: "wrap", justifyContent: "space-between" }}>
          <Box sx={(theme) => ({ flex: "0 0 49%", [theme.breakpoints.down('sm')]: {
            flex: "0 0 100%",
          }})}>
            <SelectComponent
              id="requester-type"
              label="Requestor Type"
              name="requestorType"
              required={true}
              options={MenuItemsForDropdown(
                "requesterTypes",
                selectOptions
              )}
              optionsloading={loading}
            />
          </Box>

          {captureDetailsForm?.values["requestorType"] === RequestorType.Representative ? 
            <Box sx={(theme) => ({ flex: "0 0 49%", [theme.breakpoints.down('sm')]: {
              flex: "0 0 100%",
            }})}>
              <SelectComponent
                id="representative-type"
                label="Representative Type"
                name="representativeType"
                required={true}
                options={MenuItemsForDropdown(
                  "representativeType",
                  selectOptions,
                )}
                optionsloading={loading}
              />
            </Box>
          : null}

          {captureDetailsForm?.values["requestorType"] === RequestorType.TaxPractitioner ?
            <Box sx={(theme) => ({ flex: "0 0 49%", [theme.breakpoints.down('sm')]: {
              flex: "0 0 100%",
            }})}>
              <InputFieldComponent
                id="tax-practitioner-number"
                label="Tax Practitioner Number"
                name="taxPractInfo_TPN"
                required={true}
                regex="^(PR|pr|Pr|pR)[0-9\w-]{1,7}$"
                taxPractitionerNumberCheck={true}
              />
            </Box>
          : null}
        </Box>
        
        <EntityDetails entity={captureDetailsForm?.values["requestorType"]} representativeType={captureDetailsForm?.values["representativeType"]}/>

        <EmailPhoneDetails/>
      </Box>
    </Box>
  );
};

export default CaptureRequesterDetails;
